import { createUmi } from "@metaplex-foundation/umi-bundle-defaults";
import { mplTokenMetadata } from "@metaplex-foundation/mpl-token-metadata";
import { mplBubblegum } from "@metaplex-foundation/mpl-bubblegum";
import { dasApi } from "@metaplex-foundation/digital-asset-standard-api";
import { Signer, signerIdentity } from "@metaplex-foundation/umi";
import { getRpcProxyUrl } from "./rpc-url";

// Use centralized RPC URL utility to ensure consistent URL construction
const UMI_RPC_URL = getRpcProxyUrl();

export const createUmiInstance = (signer: Signer) => {
	const umi = createUmi(UMI_RPC_URL)
		.use(mplTokenMetadata())
		.use(mplBubblegum())
		.use(dasApi())
		.use(signerIdentity(signer));

	return umi;
};
